
const nextMixedStylesbutton = document.getElementById('next-button-mixed-styles-dialog');
const successMixedStylesbutton = document.getElementById('sucess-button-mixed-styles-dialog');
const mixedStylesDialog = document.getElementById('modal-dialog-mixed-styles');
const mixedStylesStepper = document.querySelector(".mixed-styles-stepper-wrapper");
const numberOfSteps = mixedStylesStepper?.childElementCount; 

//1-indexed counter for which step the user is on
let counterStep = 1;

let observerMixedStylesDialog = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === "attributes") {
      if(!mixedStylesDialog.hasAttribute('open')) {
        localStorage.setItem('previouslyVisitedMixedStyles',true);
      }
    }
  });
});
observerMixedStylesDialog.observe(mixedStylesDialog, {
  attributes: true
});

 function initBottomControls() {
  const previouslyVisitedMixedStyles = localStorage.getItem('previouslyVisitedMixedStyles');
  if(!previouslyVisitedMixedStyles) {
    const bulletControls = document.querySelector('.modal-dialog-mixed-styles_controls > ul');
    Array.from(document.querySelectorAll('.mixed-styles-step')).map((step, idx) => {
      const bullet = document.createElement('li');
        if(idx === 0 ){
          bullet.classList.add("filled")
        } else {
          step.classList.add("hidden")
        }
        step.setAttribute("id", `mixed-styles-step-${idx + 1}`)
        bulletControls.appendChild(bullet);
      }
    )
    mixedStylesDialog.setAttribute('open', "");
  }
}

function updateBottomControls() {
  const bulletControls = document.querySelector('.modal-dialog-mixed-styles_controls > ul');
  if (bulletControls.hasChildNodes()) {
    let children = bulletControls.childNodes;
    for (let i = 0; i < children.length; i++) { 
      if(i === counterStep) {
        children[i]?.classList?.add("filled");
      } else {
        children[i]?.classList?.remove("filled")
      }
    }
  }
}

initBottomControls();

nextMixedStylesbutton.addEventListener('click', () => { 
  const modalStep = document.getElementById(`mixed-styles-step-${counterStep}`);
  const nextModalStep = document.getElementById(`mixed-styles-step-${counterStep+1}`);
  if (nextModalStep) {
    modalStep.classList.add("hidden")
    nextModalStep.classList.remove("hidden")
    counterStep++;
    if (counterStep === numberOfSteps) {
      nextMixedStylesbutton.classList.add("hidden")
      successMixedStylesbutton.classList.remove("hidden")
    }
    updateBottomControls();
  }
});

successMixedStylesbutton.addEventListener('click', () => {  
  const mixedStylesDialog = document.getElementById('modal-dialog-mixed-styles');
  mixedStylesDialog.removeAttribute('open');
});
